import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section id="cta" className="py-14 md:py-32 bg-charcoal relative overflow-hidden" data-id="element-42">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-2xl h-64 bg-sand/10 blur-[100px] pointer-events-none" data-id="element-43"></div>

      <div className="max-w-3xl mx-auto px-6 text-center relative z-10" data-id="element-44">
        <FadeIn data-id="element-45">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-offwhite mb-8 md:mb-12" data-id="element-46">
            Hay 2 opciones después de leer esto.
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-4 md:gap-8 mb-10 md:mb-16 text-left" data-id="element-47">
          <FadeIn delay={0.2} className="bg-charcoal-dark border border-charcoal-light p-8 rounded-sm opacity-70" data-id="element-48">
            <h3 className="text-xl font-heading font-bold text-offwhite-dim mb-4" data-id="element-49">
              Opción 1
            </h3>
            <p className="text-offwhite-dim" data-id="element-50">
              Cerrás esto, decís <em data-id="element-51">"lo hago después"</em>… y en 3 semanas
              seguís en el mismo loop.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} className="bg-charcoal-dark border border-sand/50 p-8 rounded-sm shadow-[0_0_30px_rgba(212,165,116,0.1)]" data-id="element-52">
            <h3 className="text-xl font-heading font-bold text-sand mb-4" data-id="element-53">
              Opción 2
            </h3>
            <p className="text-offwhite" data-id="element-54">
              Escribís <strong data-id="element-55">"RESET"</strong> por WhatsApp ahora, te mando el
              PDF + tracker, y en 7 días sentís la diferencia.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.6} className="space-y-8" data-id="element-56">
          <p className="text-xl text-offwhite-dim" data-id="element-57">
            No te pido que cambies tu vida.
          </p>
          <p className="text-2xl md:text-3xl font-heading font-bold text-amber" data-id="element-58">
            Te pido 7 días para volver a vos.
          </p>
          <p className="italic text-offwhite-dim" data-id="element-59">
            Coherencia: cuando tu cuerpo y tu alma van juntos.
          </p>

          <div className="pt-8" data-id="element-60">
            <Button href="https://wa.link/we351n" size="lg" withArrow className="shadow-2xl shadow-sand/20 w-full md:w-auto" data-id="element-61">
              WhatsApp: "RESET"
            </Button>
          </div>
        </FadeIn>
      </div>
    </section>;
}